// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GoBackFormHeader_wrap__1KDRS","link":"GoBackFormHeader_link__xGZFK","icon":"GoBackFormHeader_icon__2Kbmr"};